export default "__VITE_ASSET__717a99d3__"